import { render, staticRenderFns } from "./TeamPartial.htm?vue&type=template&id=4c776749&scoped=true&external"
import script from "./TeamPartial.js?vue&type=script&lang=js&external"
export * from "./TeamPartial.js?vue&type=script&lang=js&external"
import style0 from "./TeamPartial.scss?vue&type=style&index=0&id=4c776749&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c776749",
  null
  
)

export default component.exports